export default [
  {
    title: 'Sobre a SuperSim',
    text: `
    A SuperSim é uma de nossas parceiras que mais facilitam a concessão de crédito. A intenção é levar o “Sim” para o máximo de brasileiros possível, atendendo até mesmo pessoas com o nome negativado.
    <br />
    O empréstimo é 100% online e pode ser feito com garantia de celular ou sem garantia, também. Os valores das ofertas podem ser de R$ 500,00 a R$ 2.500,00 e podem ser pagas em até 12 parcelas.
    `,
  },
  {
    title: 'O que é empréstimo sem garantia?',
    text: `
      A principal característica do empréstimo pessoal sem garantia é não exigir que você coloque seus bens (ou seu salário) no contrato de aquisição como forma de assegurar o pagamento.
      <br />
      Caso você fique inadimplente, a instituição financeira tomará as medidas cabíveis, como negativação do CPF e tentativas de renegociação.
      <br />
      Mas, como o empréstimo não tem garantia, as taxas geralmente são mais altas em relação ao empréstimo com garantia (quando você inclui seus bens para assegurar o pagamento).
      <br />
      De maneira geral, ainda apresenta taxas de juros mais baixas e prazos maiores de pagamento em relação a outras modalidades de crédito, como cartão de crédito e cheque especial, por exemplo.
    `,
  },
  {
    title: 'O que é empréstimo com celular em garantia?',
    text: `
    Nesta modalidade de empréstimo, você oferece seu celular para a instituição financeira apenas como uma garantia de pagamento. Mas não se preocupe, o celular é seu e continua com você.
    <br />
    Em caso de inadimplência, o celular será bloqueado para uso, exceto algumas funcionalidades essenciais. Ao regularizar a fatura em aberto, seu aparelho será desbloqueado automaticamente.
    <br />
    Quando você coloca seu celular em garantia, a SuperSim oferece
    empréstimos com taxas de juros mais baixas e prazos maiores para pagar.
    `,
  },
  {
    title: 'Quais são as etapas de solicitação?',
    text: `
    <ol>
      <li>Após clicar em “Solicitar oferta”, você precisará preencher os seus dados bancários.</li>
      <li>Clique em “continuar”</li>
      <li>Depois disso, você será direcionado (a) para o site da SuperSim para dar continuidade.</li>
    </ol>
    <br />
    É só preencher todos os dados e seguir o que se pede. Após concluir essa primeira etapa, você precisará baixar o aplicativo da parceira para dar continuidade.
    `,
  },
  {
    title: 'O aplicativo da SuperSim é seguro?',
    text: `
    Sim! Você não corre nenhum risco. A parceira usa esse aplicativo para ter acesso ao seu dispositivo. Mas, não é algo que você precise se preocupar. A sua oferta com a SuperSim é de empréstimo com garantia, ou seja, caso uma parcela fique muito tempo em atraso, eles vão utilizar o seu dispositivo para garantir o pagamento. O celular não será tomado de você, mas será bloqueado para uso até que o pagamento seja realizado.
    `,
  },
  {
    title: 'Para quando é a primeira parcela? ',
    text: `
      A primeira parcela do seu empréstimo com a SuperSim é gerada automaticamente pelo sistema da parceira. Ao informar a data de pagamento do seu salário, é escolhida uma data próxima para o vencimento da sua fatura. Essa informação é passada antes da assinatura do contrato.
      <br />
      Caso haja a impossibilidade de realizar o pagamento na data escolhida, é só entrar em contato com a central de negociação da parceira através do número (11) 4003-4082, ou via e-mail cobrança@supersim.com.br
      `,
  },
  {
    title: 'Posso aumentar as parcelas ou o valor da oferta?',
    text: `
    Ao gerar uma oferta com a SuperSim, não é possível alterar os valores nem o número de parcelas. Se é a sua primeira vez contratando uma oferta, é comum o valor vir um pouco mais abaixo, mas, mostrando seu comprometimento, é possível fazer um empréstimo maior em outro momento.
    `,
  },
  {
    title: 'Faz empréstimo para negativado?',
    text: `
    Sim! Estar negativado não é um critério de reprovação com a SuperSim. Outros fatores serão avaliados para a concessão do crédito. Não deixe de tentar!
    `,
  },
  {
    title: 'Quais as formas de pagamento?',
    text: `
    O pagamento pode ser feito por boleto bancário, código pix ou cartão de crédito. Todo mês, o boleto é gerado e enviado antes do vencimento para seu e-mail, Whatsapp e SMS cadastrados. É possível acessar as vias de pagamento pelo site da SuperSim.
    `,
  },
]
